const settings = String.raw`{"timerDateTo":""}`;

export default settings;